import { render, staticRenderFns } from "./VerifyBlockedUser.vue?vue&type=template&id=e85b2366"
import script from "./VerifyBlockedUser.vue?vue&type=script&lang=js"
export * from "./VerifyBlockedUser.vue?vue&type=script&lang=js"
import style0 from "./VerifyBlockedUser.vue?vue&type=style&index=0&id=e85b2366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports